module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[108]107.9ef51d8.woff2";